module.exports = __webpack_public_path__ + "img/shrink-t.73e5d7da.svg";